module.exports = __webpack_public_path__ + "media/src/images/referrals-9564b08474047e4f3f99db7259c59cf6.jpg";